import React from 'react';
import { useLocation } from 'react-router-dom';
import { getHrefObject } from '../../../../utils/locationUtils';
import { Link } from './Link';
import { useDispatch } from 'react-redux';
import { updateOpenedSections } from '../../../../common/redux/features/docsMenu/actions';

interface CustomLinkProps {
  children: any;
  staticContext?: any;
  smooth?: boolean;
  to: string | { pathname: string; hash: string };
  onClick?: (e: any) => void;
  props?: any;
}

export const CustomLink = ({
  children,
  staticContext,
  to: _to,
  onClick,
  ...props
}: CustomLinkProps) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const toObject = typeof _to === 'string' ? getHrefObject(_to) : _to;
  const to = { ...toObject, search: location.search };

  return (
    <Link
      to={to}
      {...props}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
        dispatch(updateOpenedSections(to.pathname));
      }}
    >
      {children}
    </Link>
  );
};
